import * as React from "react";
import clsx from "clsx";
import { AnalyticsTrigger } from "../../helpers/analytics/analytics-trigger/analytics-trigger.mjs";
import { Button } from "../../button/button.mjs";
import { FormHelper } from "../form-helper/form-helper.mjs";
import { Icon } from "../../icon/icon/icon.mjs";
import { PropsChecker } from "../../helpers/props-checker/props-checker.mjs";
const NumberField = (props) => {
  var _a;
  return /* @__PURE__ */ React.createElement(
    PropsChecker,
    {
      componentName: "NumberField",
      componentProps: props,
      defaultValueName: "defaultValue",
      valueName: "value",
      onChangeNames: "onChange",
      isComponentDisabled: props.disabled || !!((_a = props.input) == null ? void 0 : _a.disabled)
    },
    /* @__PURE__ */ React.createElement(
      AnalyticsTrigger,
      {
        trigger: [
          {
            callback: "onIncrease",
            id: "NumberField - Increase - ".concat(props.id),
            elementId: props.id,
            elementType: "number",
            interactionType: "increase"
          },
          {
            callback: "onDecrease",
            id: "NumberField - Decrease - ".concat(props.id),
            elementId: props.id,
            elementType: "number",
            interactionType: "decrease"
          },
          {
            callback: "onManualChange",
            id: "NumberField - Filled - ".concat(props.id),
            elementId: props.id,
            elementType: "number",
            interactionType: "fill"
          }
        ]
      },
      /* @__PURE__ */ React.createElement(NumberInner, { ...props })
    )
  );
};
const NumberInner = (props) => {
  const {
    max = 999,
    min = 0,
    step = 1,
    defaultValue = 0,
    value,
    isInvalid,
    disabled,
    size,
    align,
    hideLabel,
    className,
    id,
    label,
    decreaseButtonText,
    increaseButtonText,
    input,
    name,
    required,
    helpMessage,
    errorMessage,
    successMessage,
    employeeMessage,
    "aria-describedby": ariaDescribedby,
    employee,
    fullWidth
  } = props;
  const [innerValue, setInnerValue] = React.useState(defaultValue);
  const [isInputEmpty, setIsInputEmpty] = React.useState(false);
  const currentValue = isValueControlled(value) ? value : innerValue;
  const isDisabled = disabled || !!(input == null ? void 0 : input.disabled);
  const invalid = isInvalid || !!errorMessage;
  function isValueControlled(outerValue = value) {
    return !!props.onChange && typeof outerValue !== "undefined";
  }
  function onDecrease(event) {
    event.preventDefault();
    setValue(currentValue - step, "decrease");
  }
  function onIncrease(event) {
    event.preventDefault();
    setValue(currentValue + step, "increase");
  }
  function onChange(event) {
    const newValue = event.currentTarget.value;
    if (newValue === "") {
      setIsInputEmpty(true);
      return;
    }
    if (props.onManualChange) {
      props.onManualChange();
    }
    setIsInputEmpty(false);
    setValue(Number(newValue), "manual");
  }
  function setValue(newValue, change) {
    var _a;
    let actualNewValue = newValue;
    if (newValue % 1 !== 0) {
      if (step && !Number.isInteger(step)) {
        if (change !== "manual") {
          actualNewValue = parseFloat(newValue.toFixed(10));
        }
      } else {
        actualNewValue = min;
      }
    }
    if (newValue < min) {
      actualNewValue = min;
    }
    if (newValue > max) {
      actualNewValue = max;
    }
    if (!isValueControlled()) {
      setInnerValue(actualNewValue);
    }
    (_a = props.onChange) == null ? void 0 : _a.call(props, actualNewValue);
    if (props.onDecrease && change === "decrease") {
      props.onDecrease(actualNewValue);
    }
    if (props.onIncrease && change === "increase") {
      props.onIncrease(actualNewValue);
    }
  }
  const getAriaDescribedBy = () => {
    const arr = [];
    if (ariaDescribedby) {
      arr.push(ariaDescribedby);
    }
    if (helpMessage) {
      arr.push("".concat(id, "-help-message"));
    }
    if (errorMessage) {
      arr.push("".concat(id, "-error-message"));
    }
    if (successMessage) {
      arr.push("".concat(id, "-success-message"));
    }
    if (employeeMessage) {
      arr.push("".concat(id, "-employee-message"));
    }
    return arr.join(" ");
  };
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: clsx(
        "numberfield",
        {
          ["numberfield--disabled"]: !!disabled,
          ["numberfield--invalid"]: !!invalid,
          ["numberfield--hide-label"]: !!hideLabel,
          ["numberfield--" + size]: !!size,
          ["numberfield--align-" + align]: !!align,
          ["numberfield--full-width"]: !!fullWidth
        },
        className
      )
    },
    /* @__PURE__ */ React.createElement("label", { htmlFor: id, className: "numberfield__label" }, employee ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Icon, { modifiers: "#support", size: "xxs", align: "middle", className: "numberfield__label-icon" }), label) : label),
    helpMessage && /* @__PURE__ */ React.createElement(FormHelper, { text: helpMessage, type: "help", id: "".concat(id, "-help-message") }),
    errorMessage && /* @__PURE__ */ React.createElement(FormHelper, { text: errorMessage, type: "error", id: "".concat(id, "-error-message") }),
    successMessage && /* @__PURE__ */ React.createElement(FormHelper, { text: successMessage, type: "valid", id: "".concat(id, "-success-message") }),
    employeeMessage && /* @__PURE__ */ React.createElement(FormHelper, { text: employeeMessage, type: "employee", id: "".concat(id, "-employee-message") }),
    /* @__PURE__ */ React.createElement("div", { className: "numberfield__inner" }, /* @__PURE__ */ React.createElement(
      Button,
      {
        className: "numberfield__button numberfield__button--decrease",
        disabled: isDisabled || currentValue === min,
        onClick: onDecrease,
        variant: "secondary",
        icon: "#minus",
        size,
        text: decreaseButtonText,
        tabIndex: -1,
        type: employee ? "employee" : void 0
      }
    ), /* @__PURE__ */ React.createElement(
      "input",
      {
        ...input,
        className: "numberfield__input",
        type: "number",
        id,
        name,
        value: isInputEmpty ? "" : currentValue,
        disabled: isDisabled,
        onChange,
        onBlur: () => setIsInputEmpty(false),
        "aria-invalid": invalid,
        "aria-describedby": getAriaDescribedBy(),
        "aria-required": required
      }
    ), /* @__PURE__ */ React.createElement(
      Button,
      {
        className: "numberfield__button numberfield__button--increase",
        disabled: isDisabled || currentValue === max,
        onClick: onIncrease,
        variant: "secondary",
        icon: "#plus",
        size,
        text: increaseButtonText,
        tabIndex: -1,
        type: employee ? "employee" : void 0
      }
    ))
  );
};
export {
  NumberField
};
